import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/Text';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride(['description'], {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);
